import React from 'react'
import { HiAcademicCap } from 'react-icons/hi'
import { MdWork } from 'react-icons/md'
import { GiTakeMyMoney } from 'react-icons/gi'
import { FaGraduationCap as FFaGraduationCap } from 'react-icons/fa'

function EducationCareer({ match }) {

    return (
        <>
            <div className='d-flex'>
                <HiAcademicCap className='match-detail-icon' />
                <div className='match-detail-title'>Education & Career</div>
            </div>
            <div className='match-detail-info'>
                <ul>
                    {match?.educationAndCareer?.qualification && match?.educationAndCareer?.college && <li><FFaGraduationCap style={{marginRight:20, color:"black"}} size={20} />  <span className='fw-bold'>{match?.educationAndCareer?.qualification}</span> from <span className='fw-bold'>{match?.educationAndCareer?.college}</span></li>}
                    {match?.educationAndCareer?.occupation && match?.educationAndCareer?.workingWith && <li><MdWork style={{marginRight:20, color:"purple"}} size={20 }/>  Working as <span className='fw-bold'> {match?.educationAndCareer?.occupation} </span> in <span className='fw-bold'>{match?.educationAndCareer?.workingWith}</span></li>}
                    {match?.educationAndCareer?.annualIncome && match?.privacy?.annualIncome ? <li><GiTakeMyMoney style={{marginRight:20, color:"green"}} size={20} />  Annual Income <span className='fw-bold'>{match?.educationAndCareer?.annualIncome}</span></li> : <li>Doesn't wish to specify her incom</li>}
                </ul>
            </div>
        </>
    )
}

export default EducationCareer